var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgNexgentvGo = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 791.084,
    height: 104.702,
    viewBox: "0 0 791.084 104.702",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath18",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 78.526h593.313V0H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.33333 0 0 -1.33333 0 104.702)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath18)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(91.095 63.382)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0l-22.754-53.548h-14.302L-59.917 0h6.171c4.99 0 9.491-2.989 11.412-7.578l4.194-10.02 8.236-22.455 8.126 22.24 4.214 10.187A12.363 12.363 0 00-6.132 0z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(125.676 20.514)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0s6.101 7.428 14.391 2.664C17.702.762 21.534.254 23.433.254c6.114 0 8.748 1.691 8.896 5.217.117 2.807-1.799 4.801-8.553 6.537-13.16 3.383-19.195 6.829-19.195 16.289 0 9.836 7.334 16.067 20.411 16.067 7.713 0 14.487-2.03 19.836-7.23l-2.547-2.537c-5.961-5.904-12.735-2.537-17.065-2.156-4.511.396-6.538-1.523-6.877-3.552-.464-2.772 1.29-5.225 8.627-6.723 13.359-2.811 19.379-7.609 19.379-16.695 0-10.583-9.03-17.14-23.329-17.14C14.925-11.669 4.839-8.625 0 0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(250.218 64.88)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0c-1.259 0-3.089-.008-5.231-.02-6.904-.039-13.125-2.91-17.605-7.493C-26.965-2.593-32.887.021-39.501.021c-1.259 0-3.089-.007-5.231-.02-13.562-.076-24.559-11.021-24.697-24.582l-.3-30.38v-.021c7.24 0 13.109 5.869 13.109 13.109V-26.266c0 7.985 6.582 14.645 14.555 14.214 7.865-.425 11.991-6.445 11.991-14.278v-13.383l-.155-15.269h13.265v.021h.109l.007 28.829c.001 2.379.486 4.763 1.627 6.852 2.395 4.384 6.94 7.394 12.231 7.245 8.142-.228 12.417-6.322 12.417-14.295v-15.543c0-7.24 5.869-13.109 13.109-13.109h.11v28.761C22.646-9.427 12.569 0 0 0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(451.507 23.131)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0c-1.708-1.192-3.688-1.765-5.045-2.034-1.026-.204-2.081-.286-3.112-.114-3.298.545-5.454 3.011-5.454 7.466v23.533h11.217v11.376h-11.11v15.168l-6.1-.65a7.962 7.962 0 01-7.119-7.916V5.318c0-13.327 7.586-19.935 19.178-19.502 0 0 6.214.043 11.986 3.931z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(416.198 64.824)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0l-2.124-.01c-13.648-.076-24.713-11.092-24.852-24.74l-.298-30.176c7.224-.087 13.109 5.743 13.109 12.948v15.417c0 7.996 6.5 14.576 14.165 14.495z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(369.985 14.319)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f4b807",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0c0 7.907-6.41 14.317-14.317 14.317-7.909 0-14.319-6.41-14.319-14.317 0-7.908 6.41-14.318 14.319-14.318C-6.41-14.318 0-7.908 0 0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(319.797 7.539)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f4b807",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0l24.23 45.048c3.747 6.965 1.137 15.647-5.827 19.393-6.965 3.746-15.646 1.137-19.392-5.828l-24.23-45.048c-3.746-6.964-1.137-15.647 5.826-19.392C-12.428-9.573-3.746-6.964 0 0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(26.723 23.131)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0c-1.708-1.192-3.688-1.765-5.045-2.034-1.026-.204-2.08-.286-3.113-.114-3.298.545-5.454 3.011-5.454 7.466v23.533h11.218v11.376h-11.11v15.168l-6.1-.65a7.962 7.962 0 01-7.119-7.916V5.318c0-13.327 7.586-19.935 19.178-19.502 0 0 6.213.043 11.986 3.931z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(560.975 49.497)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0c-8.215 0-11.601-6.622-11.451-12.497.149-5.726 3.236-11.85 11.451-11.85 8.216 0 11.303 6.174 11.402 11.9C11.502-6.572 8.216 0 0 0m0-30.372c-12.248 0-17.924 8.813-17.924 17.975 0 9.161 5.875 18.372 17.924 18.372 12 0 17.975-9.211 17.875-18.323-.1-9.012-5.627-18.024-17.875-18.024m-21.455 6.274c-3.436-3.933-7.767-6.274-13.891-6.274-13.094 0-18.423 8.615-18.423 17.776 0 9.808 6.124 18.869 18.423 18.869A18.41 18.41 0 00-22.4.945l-4.083-4.181c-2.34 2.24-5.826 3.485-8.863 3.485-7.468 0-12-5.677-12-12.845 0-5.727 3.336-11.652 12-11.652 2.739 0 5.128.598 7.867 2.789v6.174h-8.913v5.875h14.937zm33.991 39.503h-81.644v-35.559a19.743 19.743 0 015.799-14.003 19.747 19.747 0 0114.003-5.8h61.842c5.111 0 9.772 1.937 13.284 5.117a19.751 19.751 0 016.519 14.686v15.756c0 10.937-8.866 19.803-19.803 19.803"
  })))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgNexgentvGo, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/nexgentv_go.be6c06ee.svg";
export { ForwardRef as ReactComponent };